module.exports = __webpack_public_path__ + "static/media/banner-h.42d78c66.jpg";